import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  const faqs = [{
    question: '¿Funciona si tengo bebé pequeño y no duermo bien?',
    answer: 'Sí. De hecho es cuando más lo necesitas. La privación de sueño amplifica la saturación mental. Estos interruptores no reemplazan el descanso pero sí te ayudan a sacar el máximo de los momentos de lucidez que tienes disponibles.'
  }, {
    question: '¿Cuánto tiempo tarda en verse el efecto?',
    answer: 'El efecto del interruptor se siente el mismo día que lo aplicas. El cambio en tu negocio se nota en 2 a 3 semanas de práctica consistente.'
  }, {
    question: '¿Necesito algún material especial o suplementos?',
    answer: 'Solo necesitas tu cuerpo y un vaso de agua. Absolutamente nada más.'
  }, {
    question: '¿Es solo otro libro de meditación?',
    answer: 'No. La meditación es pasiva. Estos interruptores son activos. Son instrucciones físicas precisas que le das a tu cuerpo para cambiar de estado en 60 segundos. Si en 3 minutos no sientes diferencia, algo estás haciendo mal y te explicamos exactamente qué.'
  }, {
    question: '¿Y si no me funciona?',
    answer: 'Tienes 7 días de garantía total. Si no notas diferencia, te devuelvo el dinero sin preguntas.'
  }, {
    question: '¿En qué formato llega el manual?',
    answer: 'PDF descargable. Lo puedes leer en el teléfono, tablet o computadora. Y puedes imprimir la guía rápida para tenerla en tu escritorio.'
  }, {
    question: '¿Cuándo recibo el acceso?',
    answer: 'Inmediatamente después del pago. Recibes el enlace de descarga en tu correo en menos de 2 minutos.'
  }];
  return <section className="w-full bg-white px-4 md:px-6 py-6 md:py-24 text-center" data-id="element-84">
      <div className="max-w-3xl mx-auto" data-id="element-85">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-86">
          <h2 className="font-['Playfair_Display'] text-2xl md:text-4xl lg:text-5xl font-bold text-[#2D2D2D] mb-5 md:mb-12" data-id="element-87">
            Preguntas <span className="text-[#E8734A]" data-id="element-88">frecuentes</span>
          </h2>

          <div className="space-y-2 md:space-y-4 text-left" data-id="element-89">
            {faqs.map((faq, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 10
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.4,
            delay: index * 0.05
          }} className="bg-[#FFF8F0] rounded-lg md:rounded-xl overflow-hidden border border-[#F5E6DC]" data-id="element-90">
                <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full px-4 md:px-8 py-3 md:py-6 flex items-center justify-between text-left hover:bg-[#F5E6DC] transition-colors" data-id="element-91">
                  <span className="font-bold text-base md:text-lg text-[#2D2D2D] pr-3 md:pr-4" data-id="element-92">
                    {faq.question}
                  </span>
                  <motion.div animate={{
                rotate: openIndex === index ? 180 : 0
              }} transition={{
                duration: 0.3
              }} data-id="element-93">
                    <ChevronDownIcon className="w-5 md:w-6 h-5 md:h-6 text-[#E8734A] flex-shrink-0" data-id="element-94" />
                  </motion.div>
                </button>

                <AnimatePresence data-id="element-95">
                  {openIndex === index && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.3
              }} className="overflow-hidden" data-id="element-96">
                      <div className="px-4 md:px-8 pb-3 md:pb-6" data-id="element-97">
                        <p className="text-[#2D2D2D] leading-relaxed font-medium opacity-90 text-sm md:text-base" data-id="element-98">
                          {faq.answer}
                        </p>
                      </div>
                    </motion.div>}
                </AnimatePresence>
              </motion.div>)}
          </div>
        </motion.div>
      </div>
    </section>;
}